import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import bannerImage from "../assets/img/bnr1.png";
import iq1 from "../assets/img/iq1.png";
import webbg2 from "../assets/img/webbg2.png";
import eli from "../assets/img/eli.png";
import eli2 from "../assets/img/eli2.png";
import about from "../assets/img/about.png";
import icon1 from "../assets/img/ser1.png";
import icon2 from "../assets/img/ser2.png";
import icon3 from "../assets/img/ser3.png";
import icon4 from "../assets/img/ser4.png";
import icon5 from "../assets/img/ser5.png";
import icon6 from "../assets/img/ser6.png";


// client
import op9 from "../assets/img/op9.png";
import op10 from "../assets/img/op10.png";
import op11 from "../assets/img/op11.png";
import op14 from "../assets/img/op14.png";
import op12 from "../assets/img/op12.png";
import op13 from "../assets/img/op13.png";
import op15 from "../assets/img/op15.png";
import op16 from "../assets/img/op16.png";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet-async";

export default function Home() {
  const settings = {
    dots: false,          // neeche dots nahi chahiye
    infinite: true,       // loop hoga
    speed: 500,           // transition speed
    slidesToShow: 7,      // ek time me kitne images show hongi
    slidesToScroll: 1,    // ek bar me kitne scroll honge
    autoplay: true,       // auto scroll
    autoplaySpeed: 2000,  // 2 sec delay
    arrows: false,        // arrows hide
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };


  const settings2 = {
    dots: false,          // neeche dots nahi chahiye
    infinite: true,       // loop hoga
    speed: 500,           // transition speed
    slidesToShow: 2,      // ek time me kitne images show hongi
    slidesToScroll: 1,    // ek bar me kitne scroll honge
    autoplay: true,       // auto scroll
    autoplaySpeed: 2000,  // 2 sec delay
    arrows: false,        // arrows hide
    responsive: [
      {
        breakpoint: 1024,
        settings2: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings2: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings2: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <>
	 <Helmet>
        <title>Best Website Development Company in Ghaziabad</title>
        <meta name="description" content="StockCod: The best website development company in Ghaziabad, offering innovative responsive designs, and expert development services. Call 9540815561" />
      </Helmet>
	<section 
    style={{
        backgroundImage: `url(assets/img/webbg.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        }} 
        className="mobilebnr">
		<div className="headerbanerstr">
		<div className="outerofbanner">
			<div className="container">
				<div className="overlayset" style={{backgroundImage: `url(${eli})`}}>
				</div>
				<div className="row">
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="bannertext">
							<h1>Website Development & Services for <span>Your Business's Support</span></h1>
							<p>Stock Code best website development company in Ghaziabad We work together to support brands in anticipating disruptive opportunities in the future, planning for them, and developing new avenues for growth in a sustainable economy.</p>
							<div className="webbtn">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Get Started</a>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="bannersideimg">
							<img src={bannerImage} alt="dest website development company in ghaziabad" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="outerofcounterdown">
			<div className="count-area" data-diff="100">
			    <div className="container">
			        <div className="row">
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">2</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Year of Experience</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">80</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Happy Client</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">150</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Complete Project</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">10</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Team Members</div>
			                </div>
			            </div>
			        </div>
			    </div>
			  </div>
		</div>
	</div>
	</section>
	<section className="sectionpadding" 
	style={{
		backgroundImage: `url(${webbg2})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover"}}>
		<div className="background-overlay overlay-about"></div>
		<div className="outerofabout">
			<div className="container">
				<div className="row rowaboutset">
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="aboutcontent">
							<div className="sectionheading">
								<h2>Grow Your Business with <span>StockCod</span></h2>
							</div>
							<p>StockCod, a digital agency that has been in operation for over a decade, was founded with the goal of providing customers with everything feasible, successful, and exceptional digital marketing ways to boost a brand's visibility, online presence, and insights.</p>
							<div className="webbtn">
								<Link to="/about-us">Read More</Link>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="aboutimg">
							<img src={about} alt="Top Digital Marketing Company in Ghaziabad" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section className="servsection sectionpadding" 
	style={{
	backgroundImage: `url(assets/img/webbg2.jpg)`,
	backgroundRepeat: "no-repeat",
	backgroundSize: "cover"}}
	>
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" 
		style={{
			backgroundImage: `url(${eli2})`
			}}
			>
				</div>
		<div className="outerofservices">
			<div className="container">
				<div className="sectionheading heading-mb">
					<h2>What <span>we do</span></h2>
					<p>Stock Cod offers a full spectrum of digital marketing services, from SEO and PPC to content marketing and social media management, tailored to drive your online success.</p>
				</div>
				<div className="row">
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon1} alt="web site development" />
							</div>
							<div className="sercontent">
								<h3>Web Site Development</h3>
								<p>Your company's website is one of the most effective tools for establishing a strong internet presence. A professional web design will assist you in making a favorable first impression on your target audience.</p>
								<div className="webbtn1">
									<Link to="/website-development">Read More</Link>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon2} alt="Search Engine Optimization" />
							</div>
							<div className="sercontent">
								<h3>Search Engine Optimization</h3>
								<p>Increase your website's visibility and organic traffic with our results-driven Search Engine Optimization service.
								Dominate search engine rankings and stay ahead of the competition with our expert SEO strategies.</p>
								<div className="webbtn1">
									<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon3} alt="Graphic Design" />
							</div>
							<div className="sercontent">
								<h3>Graphic Design</h3>
								<p>Graphic design is essential in modern marketing and gives businesses a competitive advantage. Your company requires appealing images, efficient idea communication, and increased trust to drive traffic to your brand.</p>
								<div className="webbtn1">
									<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon4} alt="Video Editing" />
							</div>
							<div className="sercontent">
								<h3>Video Editing</h3>
								<p>Experience professional-grade Video Editing with our expert team, delivering polished and captivating videos for all your needs.
								Transform your raw footage into stunning visual stories with our top-notch Video Editing service.</p>
								<div className="webbtn1">
									<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon5} alt="Mothion Graphic" />
							</div>
							<div className="sercontent">
								<h3>Mothion Graphic</h3>
								<p>Enhance your brand's visual appeal with our professional Motion Graphic service, crafting dynamic animations that stand out from the crowd.
								Transform your ideas into captivating motion visuals with our expert team.</p>
								<div className="webbtn1">
									<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								<img src={icon6} alt="Social Media Marketing" />
							</div>
							<div className="sercontent">
								<h3>Social Media Marketing</h3>
								<p>Amplify your brand's presence with our Social Media Marketing service, reaching and engaging your target audience effectively.
								Boost your online visibility & drive results with our expert Social Media Marketing strategies.</p>
								<div className="webbtn1">
									<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Read More</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    <section  className="servsection sectionpadding" 
	style={{
		backgroundImage: `url(assets/img/webbg2.jpg)`, 
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover"
		}}>
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" style={{backgroundImage: `url(assets/img/eli2.png)`}}>
				</div>
    	<div className="outerofservices">
    		<div className="container">
    			<div className="sectionheading heading-mb">
					<h2>Website Design <span>Packages</span></h2>
				</div>
				<div className="row rowcontent justify-content-center">
					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">Startup</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
									₹5,999
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">5 Pages</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">1 Contact Form With Enquiry Form Popup</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">5 Times Changes</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 30 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">Small Business</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
								₹15,000
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Upto 10 Pages</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Logo</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Dynamic Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Login Details Will be Given</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">2 Contact Form</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">1 Email ID</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Whatsap & Call Button</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Testimonials</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">7 Times Changes</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 60 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">E-Commerce</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
									₹21,000
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Logo</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">10 Product Add</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WhatsApp & Call Button Integration</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Login Details Will be Given</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Payment Gateway International</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Dynamic Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Testimonials</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 60 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>
				</div>
    		</div>
    	</div>
    </section>   
	<section className="sectionpadding" 
	style={{
		backgroundImage: `url(assets/img/webbg2.jpg)`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover"}}
		>
		<div className="background-overlay overlay-whyus"></div>
		<div className="outerofwhyus">
			<div className="container">
				<div className="row">
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="whyusbox">
							<div className="sectionheading">
								<p>OUR BENEFITS</p>
								<h2>We Have <span className="chooseus">A Lot To Offer</span></h2>				
							</div>
							<p>We are grateful for your trust. Because they know we are the best, our clients choose us and our products.</p>
							<ul>
								<li><i className="fa fa-arrow-circle-right" aria-hidden="true"></i> Top Design Freedom</li>
								<li><i className="fa fa-arrow-circle-right" aria-hidden="true"></i> Create Value Strategy</li>
							</ul>
						</div>
					</div>
					<div className="col-lg-6 col-md-12 col-sm-12">
						<div className="whyusquality">
							<div className="qualitybox">
								<div className="iconofquality">
									<img src={iq1} alt='' />
								</div>
								<h3>All Sizes Business</h3>
							</div>
							<div className="qualitybox">
								<div className="iconofquality">
									<img src={iq1} alt="" />
								</div>
								<h3>Lead Generation</h3>
							</div>
							<div className="qualitybox">
								<div className="iconofquality">
									<img src={iq1} alt="" />
								</div>
								<h3>Search Engine Optimization</h3>
							</div>
							<div className="qualitybox">
								<div className="iconofquality">
									<img src={iq1} alt="" />
								</div>
								<h3>Online Brand Design</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	 
	<section className="sectionpadding ourparntersection">
		<div className="outerofourpartner">
			<div className="outparnterslide">
				<div className="outerofourpartner">
					<Slider {...settings} className="outparnterslide">
						<div className="ourpartnerbox">
							{/* <img src="assets/img/op9.png" /> */}
							<img src={op9} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op10} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op11} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op14} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op16} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op12} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op15} alt="" />
						</div>
						<div className="ourpartnerbox">
							<img src={op13} alt="" />
						</div>
					</Slider>
				</div>
			</div>
		</div>
	</section>
	<section className="sectionpadding" 
	style={{
	backgroundImage: `url(assets/img/webbg2.jpg)`,
	backgroundRepeat: "noRepeat",
	backgroundSize: "cover"}}
	>
		<div className="background-overlay overlay-whyus"></div>
		<div className="outeroftestimonial">
			<div className="sectionheading">
				<h2>Trusted by Professionals <span className="chooseus">All Over the World</span></h2>
				<p>The importance of SEO services for companies seeking to attract new customers and increase traffic cannot be overstated.</p>
			</div>
			<div className="container">
				<div className="owlslider">
					<Slider {...settings2} className="outparnterslide">
						<div className="outeroftestimonial">
							<div className="testimonialbox">
								<ul>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
								</ul>
								<p><b>Outstanding Service !</b><br /> Best Website Development provided top-notch design and functionality for my site, exceeding all expectations. Their team is professional, responsive, and highly skilled. Highly recommend!</p>
								<div className="testimonialinfo">
									<div className="usernametesti">
										<p>Nirshad Ahmad</p>
										{/* <p className="valuetesti">Entrepreneur</p> --> */}
									</div>
									<div className="usertestiimg">
										<img src="assets/img/user12.jpg" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="outeroftestimonial">
							<div className="testimonialbox">
								<ul>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
								</ul>
								<p><b>Excellent Value and Experience:</b><br />Best Price offers unbeatable rates for top-notch stock services. The experience was smooth, &amp; their customer support was superb. Highly recommend it for both affordability and quality!</p>
								<div className="testimonialinfo">
									<div className="usernametesti">
										<p>Nitin Kumar</p>
										{/* <!-- <p className="valuetesti">Entrepreneur</p> --> */}
									</div>
									<div className="usertestiimg">
										<img src="assets/img/user11.jpg" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="outeroftestimonial">
							<div className="testimonialbox">
								<ul>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
								</ul>
								<p><b>Fantastic Experience</b><br />Best Website Development delivered a beautiful, user-friendly website with exceptional attention to detail. Their customer service was prompt and professional. Highly recommend!</p>
								<div className="testimonialinfo">
									<div className="usernametesti">
										<p>Parmod Chikhle</p>
										{/* <!-- <p className="valuetesti">Entrepreneur</p> --> */}
									</div>
									<div className="usertestiimg">
										<img src="assets/img/user13.jpg" alt="" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="outeroftestimonial">
							<div className="testimonialbox">
								<ul>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
									<li><i className="fa fa-star" aria-hidden="true"></i></li>
								</ul>
								<p><b>Top-Notch SEO Services!</b><br />I had an amazing experience with Best SEO. They significantly boosted my site's traffic and search rankings. Their team is knowledgeable, responsive, and delivers excellent results. Highly recommend!</p>
								<div className="testimonialinfo">
									<div className="usernametesti">
										<p>Vishal</p>
										{/* <p className="valuetesti">Entrepreneur</p>  */}
									</div>
									<div className="usertestiimg">
										<img src="../../assets/img/user14.jpg" alt="" />
									</div>
								</div>
							</div>
						</div>
					</Slider>
				</div>
			</div>		
		</div>
	</section>
    </>
  )
}
